/* PLAB-05 (#78). Was an inline <script> in snippets/multi-selectors.liquid, which renders in
   the footer, the footer payments row and the toolbar - so these 8.7 KB were re-parsed on
   every navigation of every page. The snippet now loads this file with defer. The
   window.__multiSelectorsEnhancer guard below is what keeps the three copies to one run. */

(function () {
  if (window.__multiSelectorsEnhancer) return;
  window.__multiSelectorsEnhancer = true;

  const OPEN_CLASS = 'disclosure-list--visible';
  const PORTAL_Z = 2147483646;
  const MIN_W = 260;          // lock width on open (min)
  const MAX_W = 560;          // lock width on open (max)
  const MAX_VH = 0.6;         // max height as fraction of viewport

  let portal = null;
  let active = null;          // { list, toggle, width }

  function ensurePortal() {
    if (portal) return portal;
    portal = document.createElement('div');
    portal.className = 'disclosure-portal';
    portal.style.position = 'fixed';
    portal.style.zIndex = String(PORTAL_Z);
    portal.style.pointerEvents = 'none';
    document.body.appendChild(portal);
    return portal;
  }

  function normalize(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }

  function injectSearch(ul) {
    if (ul.querySelector('.disclosure-list__search')) return;
    const li = document.createElement('li');
    li.className = 'disclosure-list__search';
    li.innerHTML = '<input class="disclosure-search__input" type="search" placeholder="Search…" autocomplete="off" aria-label="Filter">';
    ul.insertBefore(li, ul.firstChild);
  }

  function focusWithoutJump(el) {
    const x = window.scrollX, y = window.scrollY;
    try { el.focus({ preventScroll: true }); } catch {}
    window.scrollTo(x, y);
  }

  function computePos(toggleEl, listEl, fixedWidth) {
    const r = toggleEl.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    const pad = 8;

    // width is locked on open
    const width = fixedWidth != null
      ? fixedWidth
      : Math.min(Math.max(Math.max(r.width, MIN_W), MIN_W), Math.max(MIN_W, Math.min(MAX_W, vw - pad*2)));

    // measure intended height (natural, clamped to MAX_VH)
    const maxH = Math.floor(vh * MAX_VH);
    const wantH = Math.min(listEl.scrollHeight || 320, maxH);

    // decide up/down
    let openDown = (r.bottom + wantH + pad) <= vh;
    if (!openDown && (r.top - wantH - pad) < 0 && (vh - r.bottom) >= r.top) openDown = true;

    let top = openDown ? (r.bottom + 6) : (r.top - wantH - 6);
    let left = listEl.classList.contains('disclosure-list--left') ? (r.right - width) : r.left;

    left = Math.min(Math.max(left, pad), vw - width - pad);
    top  = Math.min(Math.max(top,  pad), vh - wantH - pad);

    return { top, left, width, height: wantH };
  }

  // --- Dynamic height (no “stuck” heights) ---
  const scheduleFit = (() => {
    let raf;
    return (ul) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => fitList(ul));
    };
  })();

  function fitList(listEl) {
    if (!listEl) return;
    const max = Math.floor(window.innerHeight * MAX_VH);

    // let content define size, then clamp if needed
    listEl.style.height = 'auto';
    listEl.style.maxHeight = '';
    void listEl.offsetHeight; // reflow to refresh scrollHeight

    const natural = Math.ceil(listEl.scrollHeight);
    if (natural <= max) {
      listEl.style.height = '';
      listEl.style.maxHeight = max + 'px';   // ceiling only
    } else {
      listEl.style.height = max + 'px';
      listEl.style.maxHeight = max + 'px';   // clamp
    }

    // keep position correct after size changed
    if (active?.list === listEl) reposition();
  }

  function openList(listEl, toggleEl) {
    const p = ensurePortal();

    if (!listEl._origParent) {
      listEl._origParent = listEl.parentNode;
      listEl._origNext   = listEl.nextSibling;
    }

    injectSearch(listEl);

    listEl.style.display = 'block';
    listEl.classList.add(OPEN_CLASS);
    p.appendChild(listEl);

    // lock width on open (independent of filtering)
    const r = toggleEl.getBoundingClientRect();
    const vw = window.innerWidth;
    const pad = 8;
    const width = Math.min(
      Math.max(Math.max(r.width, MIN_W), MIN_W),
      Math.max(MIN_W, Math.min(MAX_W, vw - pad*2))
    );

    active = { list: listEl, toggle: toggleEl, width };

    p.style.width = width + 'px';
    listEl.style.width = '100%';
    listEl.style.overflowY = 'auto';

    // size to current content (pre-filter) and position
    fitList(listEl);
    reposition();

    const search = listEl.querySelector('.disclosure-search__input');
    if (search) focusWithoutJump(search);

    /* I18N-03 (#160): written after the focus move, not before it. Focus leaving the toggle for the
       portal makes assets/disclosure.js set aria-expanded="false", so the open list was announced as
       collapsed. */
    toggleEl.setAttribute('aria-expanded', 'true');

    window.addEventListener('scroll', reposition, { passive: true, capture: true });
    window.addEventListener('resize', onResize, { passive: true });
    document.addEventListener('pointerdown', onDocPointerDown, true);
    document.addEventListener('keydown', onKey, true);
  }

  function resetFilter(listEl) {
    const search = listEl.querySelector('.disclosure-search__input');
    if (search) search.value = '';
    listEl.querySelectorAll('.disclosure-list__item').forEach(li => {
      li.style.display = '';
    });
    listEl.scrollTop = 0;
    listEl.classList.remove('is-filtered');
  }

  function closeList() {
    if (!active) return;
    const { list, toggle } = active;

    // clear search + restore items
    resetFilter(list);

    list.classList.remove(OPEN_CLASS);
    list.style.display   = '';
    list.style.width     = '';
    list.style.maxHeight = '';
    list.style.height    = '';

    if (list._origParent) list._origParent.insertBefore(list, list._origNext);
    toggle?.setAttribute('aria-expanded', 'false');
    active = null;

    window.removeEventListener('scroll', reposition, true);
    window.removeEventListener('resize', onResize, true);
    document.removeEventListener('pointerdown', onDocPointerDown, true);
    document.removeEventListener('keydown', onKey, true);
  }

  function onResize() {
    if (!active) return;
    fitList(active.list);  // recalc height for new viewport
    reposition();
  }

  function reposition() {
    if (!active) return;
    const { list, toggle, width } = active;
    const pos = computePos(toggle, list, width);
    portal.style.top   = pos.top + 'px';
    portal.style.left  = pos.left + 'px';
    portal.style.width = width + 'px';
  }

  /* I18N-03 (#160): Escape hands focus back to the toggle. closeList moves the list, and the focus
     inside it, back into the form, which left focus on <body>. */
  function onKey(e) {
    if (e.key !== 'Escape' || !active) return;
    const toggle = active.toggle;
    closeList();
    if (toggle) focusWithoutJump(toggle);
  }

  function onDocPointerDown(e) {
    if (!active) return;
    const inPortal = portal.contains(e.target);
    const sameToggle = e.target.closest('[data-disclosure-toggle]') === active.toggle;
    if (!inPortal && !sameToggle) closeList();
  }

  // SEARCH (delegated)
  document.addEventListener('input', function (e) {
    const input = e.target.closest('.disclosure-search__input');
    if (!input) return;

    const ul = input.closest('.disclosure-list');
    const q = normalize(input.value.trim());

    ul.querySelectorAll('.disclosure-list__item').forEach(li => {
      if (li.classList.contains('disclosure-list__search')) return;
      const label = normalize(li.textContent);
      li.style.display = q ? (label.includes(q) ? '' : 'none') : '';
    });

    // grow/shrink height to fit current results
    scheduleFit(ul);
  });

  // OPEN/CLOSE handling (width lock, dynamic height)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-disclosure-toggle]');
    if (!btn) return;

    const listId = btn.getAttribute('aria-controls');
    const listEl = document.getElementById(listId);
    if (!listEl) return;

    e.preventDefault(); // we control the toggle

    if (active && active.list === listEl) { closeList(); return; }
    closeList();
    openList(listEl, btn);
  });

  // OPTION SELECT (submit Shopify form after teleport)
  document.addEventListener('click', function (e) {
    const a = e.target.closest('.disclosure-list__option');
    if (!a) return;

    const ul = a.closest('.disclosure-list');
    if (!ul) return;

    const form = ul.closest('form');
    const disclosure = ul.closest('at-disclosure') || ul.closest('.disclosure');

    const value = a.getAttribute('data-value');
    if (!value) return;

    e.preventDefault();

    const isCurrency = disclosure?.hasAttribute('data-disclosure-currency');
    const isLocale   = disclosure?.hasAttribute('data-disclosure-locale');

    if (isCurrency) {
      const input = form.querySelector('input[name="country_code"]');
      if (input) input.value = value;
      form.submit();
      closeList();
      return;
    }
    if (isLocale) {
      /* I18N-03 (#160): T2 renamed the localization form's hidden field from locale_code to
         language_code, Shopify's documented name. This branch is harmless today: disclosure.js
         submits the form before this handler runs, and while the list sits in the portal,
         ul.closest('form') is null here, so the selector never matches either name. Kept in step
         with the form's real field name for the day this branch does run. */
      const input = form.querySelector('input[name="language_code"]');
      if (input) input.value = value;
      form.submit();
      closeList();
      return;
    }
  });

  // Pre-inject search rows (safe if repeated)
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.disclosure-list').forEach(injectSearch);
  });
})();
